/**
 * The raw persisted game-handle knowledge (multiplayer-surface design § Structure): the
 * `skat.gameId` localStorage key plus bare read/persist/remove — nothing else. `api.js` keeps its
 * own layer on top, unchanged in semantics and signatures: the per-tab `currentGameId` cache and
 * `clearCurrentGame`'s sibling-tab compare-and-remove guard (round-2 finding — moving those here
 * too would either drag the cache+guard along or split one key between two divergent readers).
 * `multiplayer-page.js` imports only {@link persistGameHandle} — the minimum second concrete use
 * that earns this shared home (CODING § locality over shared utilities). A document page importing
 * this module pulls no api.js module graph.
 */

export const GAME_ID_STORAGE_KEY = "skat.gameId";

export function readGameHandle() {
  return localStorage.getItem(GAME_ID_STORAGE_KEY);
}

export function persistGameHandle(gameId) {
  localStorage.setItem(GAME_ID_STORAGE_KEY, gameId);
}

export function removeGameHandle() {
  localStorage.removeItem(GAME_ID_STORAGE_KEY);
}
